import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { usePermissions } from '@/hooks/usePermissions';
import { useBillingState, daysUntil } from '@/api/queries/billing';

// ─────────────────────────────────────────────────────────────
// Global free-period banner (AppLayout): shown only while the tenant is
// TRIALING, counting down to its own trialEndsAt. The launch offer is
// never named here — /public/offer describes the offer sold today, not
// the one this tenant signed up under. Renders nothing without
// billing:read and swallows errors.
// ─────────────────────────────────────────────────────────────

export function TrialBanner() {
  const { hasPermission } = usePermissions();
  const canReadBilling = hasPermission('billing:read');
  const { data: billing } = useBillingState({ enabled: canReadBilling });

  if (!canReadBilling || !billing) return null;
  if (billing.status !== 'TRIALING' || !billing.trialEndsAt) return null;

  const remaining = daysUntil(billing.trialEndsAt);

  return (
    <div
      role="status"
      className="mb-4 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-blue-200 bg-blue-50 px-4 py-3"
    >
      <div className="flex items-center gap-2 text-sm text-blue-800">
        <Clock className="h-4 w-4 flex-shrink-0 text-blue-600" />
        <span className="font-semibold">Période gratuite — J-{remaining}</span>
        <span className="hidden sm:inline text-blue-700">
          Votre période gratuite se termine le{' '}
          {new Date(billing.trialEndsAt).toLocaleDateString('fr-FR')}.
        </span>
      </div>
      <Link
        to="/parametres/abonnement"
        className="text-sm font-medium text-blue-800 underline underline-offset-2 hover:text-blue-900"
      >
        Choisir mon abonnement
      </Link>
    </div>
  );
}

export default TrialBanner;
